import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/chrome/AppShell";
import { sessionQueryOptions, useSession } from "@/lib/session";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions);
    if (!session) {
      // TanStack Router uses thrown redirects as control flow; the value is not an Error instance.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
        replace: true,
      });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const { data } = useSession();
  return (
    <AppShell userLabel={data?.user.email ?? null}>
      <Outlet />
    </AppShell>
  );
}
